import UserDriverEditFormRequest from "../../../../api/raily/user/driver/edit-form/user-driver-edit-form.request";
import UserDriverEditFormParams from "./user-driver-edit-form-params";

const create = (
  params: UserDriverEditFormParams,
): UserDriverEditFormRequest => {
  return {
    id: params.id,
  };
};

const userDriverEditFormParamsFactory = {
  create,
};

export default userDriverEditFormParamsFactory;
